// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-modal-link {
	color: rgb(0, 51, 51);
	font-size: 0.78rem;
	font-weight: 500;
	text-decoration: none;
}

.auth-modal-link:hover {
	text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/modal-login/modal-login.component.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,0BAA0B;AAC3B","sourcesContent":[".auth-modal-link {\n\tcolor: rgb(0, 51, 51);\n\tfont-size: 0.78rem;\n\tfont-weight: 500;\n\ttext-decoration: none;\n}\n\n.auth-modal-link:hover {\n\ttext-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
